// Mock data for Pigmentos Loja de Tintas

export const companyInfo = {
  name: "Pigmentos Loja de Tintas",
  address: "Rua José Malhoa 16, 2780-040 Oeiras, Portugal",
  phone: "+351 913 323 197",
  // Segundo telemovel da loja. Entrou no site a 07/09/2026 por decisao da Licinia:
  // e um dos tres que a loja tem afixados na porta e eles querem-nos todos ca.
  // ⚠️ NAO e o numero de accao: WhatsApp, anuncios e criativos ficam no `phone`.
  phone2: "+351 967 531 170",
  // Fixo da loja. Confirmado pela Licinia 07/08/2026; e o que ja esta no perfil Google,
  // e a coerencia do NAP entre perfil, site e diretorios conta para SEO local.
  // ⚠️ NAO usar em WhatsApp nem como CTA principal: esses ficam no telemovel.
  landline: "+351 210 997 590",
  email: "pigmentos.geral@gmail.com",
  instagram: "https://www.instagram.com/pigmentosoeiras",
  facebook: "https://www.facebook.com/PigmentosOeiras",
  logo: "/assets/logo-pigmentos.webp"
};

export const catalogs = [
  {
    id: 1,
    name: "CIN",
    description: "Catálogo completo de cores CIN para todos os seus projetos.",
    link: "https://cin.com/deco/pt/en/all-colours",
    color: "#E65100"
  },
  {
    id: 2,
    name: "ARGA",
    description: "Explore a paleta de cores ARGA para acabamentos perfeitos.",
    link: "https://www.argatintas.pt/uploads/rte/Ficheiros/catalogo_cores.pdf",
    color: "#1565C0"
  },
  {
    id: 3,
    name: "NATURCLAY",
    description: "Tintas naturais e ecológicas para uma construção sustentável.",
    link: "https://naturclay.com/pt/tintas-naturais/",
    color: "#2E7D32"
  }
];

export const products = [
  {
    id: 1,
    name: "CIN",
    description: "Líder em tintas e vernizes em Portugal. Soluções completas para decoração e proteção.",
    catalogLink: "/assets/catalogo-cin-cores.pdf",
    color: "#E30613",
    logo: "/assets/brand-cin.webp"
  },
  {
    id: 2,
    name: "ARGA",
    description: "Tintas de alta qualidade para interiores e exteriores. Acabamentos perfeitos.",
    catalogLink: "https://www.argatintas.pt/uploads/rte/Ficheiros/catalogo_cores.pdf",
    color: "#1565C0",
    logo: "/assets/brand-arga.jpg"
  },
  {
    id: 3,
    name: "PENTRILO",
    description: "Ferramentas e acessórios profissionais para pintura e decoração.",
    catalogLink: "/assets/catalogo-pentrilo-26-27.pdf",
    color: "#FF5722",
    logo: "/assets/brand-pentrilo.png"
  },
  {
    id: 4,
    name: "KCBERRY",
    description: "Microcimento e revestimentos decorativos de alto desempenho.",
    catalogLink: "https://microcimento.pt/cores/",
    color: "#A31621",
    logo: "/assets/brand-kcberry.png"
  },
  {
    id: 5,
    name: "NATURCLAY",
    description: "Tintas naturais e ecológicas para construção sustentável e bioconstrução.",
    catalogLink: "/assets/catalogo-naturclay-cores.pdf",
    color: "#6B8E23",
    logo: "/assets/brand-naturclay.jpg"
  },
  {
    id: 6,
    name: "WERKU",
    description: "Ferramentas profissionais e equipamentos para pintura e construção.",
    catalogLink: "/assets/catalogo-werku.pdf",
    color: "#1a1a1a",
    logo: "/assets/brand-werku.png"
  },
  {
    id: 7,
    name: "PROA",
    description: "Esmaltes e sintéticos para ferro e madeira, com gama industrial e esmalte marítimo.",
    catalogLink: "/assets/catalogo-proa-esmaltes.pdf",
    color: "#B4002D",
    logo: "/assets/brand-proa.png"
  },
  {
    id: 8,
    name: "MATESICA",
    description: "Tintas, primários e impermeabilizantes para fachadas, paredes e telhados, com as fichas técnicas do fabricante.",
    catalogLink: "/tintas-matesica/",
    color: "#B45309",
    logo: "/assets/brand-matesica.png"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Sala de Estar Moderna",
    category: "Interior",
    image: "https://images.unsplash.com/photo-1696654149330-3a2f705a28a5?w=800"
  },
  {
    id: 2,
    title: "Acabamento Decorativo",
    category: "Decorativo",
    image: "https://images.unsplash.com/photo-1610422218546-42b7f1f84dbd?w=800"
  },
  {
    id: 3,
    title: "Cores Vibrantes",
    category: "Interior",
    image: "https://images.unsplash.com/photo-1725781745978-9531b0e1b4e3?w=800"
  },
  {
    id: 4,
    title: "Textura Natural",
    category: "Exterior",
    image: "https://images.unsplash.com/photo-1697561608795-8a384d1f4790?w=800"
  },
  {
    id: 5,
    title: "Paleta de Cores",
    category: "Mistura",
    image: "https://images.pexels.com/photos/5292188/pexels-photo-5292188.jpeg?w=800"
  },
  {
    id: 6,
    title: "Construção Sustentável",
    category: "Exterior",
    image: "https://images.pexels.com/photos/1446378/pexels-photo-1446378.jpeg?w=800"
  }
];

export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Sobre Nós",
      products: "Produtos",
      customMix: "Mistura Personalizada",
      simulation: "Simulação",
      catalogs: "Catálogos",
      portfolio: "Portfólio",
      contact: "Contactos"
    },
    hero: {
      title: "Encontre a cor ideal para o seu projeto.",
      subtitle: "Tintas profissionais, mistura personalizada e soluções sustentáveis para construção.",
      cta: "Descubra Mais",
      secondary: "Misturamos a cor que deseja, à sua medida."
    },
    highlights: {
      mix: {
        title: "Mistura Personalizada",
        description: "Criamos a cor à medida do seu espaço com tecnologia de ponta."
      },
      variety: {
        title: "Variedade em Tintas",
        description: "Ampla gama de tintas profissionais das melhores marcas."
      },
      natural: {
        title: "Soluções Naturais",
        description: "Produtos ecológicos para construção sustentável e bioconstrução."
      }
    },
    about: {
      title: "Sobre Nós",
      subtitle: "PIGMENTOS nasceu a pensar em si",
      text1: "Na PIGMENTOS, somos especialistas em tintas, com mais de 20 anos de experiência no mercado. Ao longo dos anos, conhecemos de perto as necessidades de quem constrói, renova e transforma espaços, desde profissionais do setor até clientes particulares.",
      text2: "Disponibilizamos uma vasta gama de soluções em tintas e serviços, aliando qualidade, preços competitivos e uma localização estratégica, com estacionamento disponível para maior comodidade. Mais do que vender produtos, oferecemos um atendimento personalizado, ajudando a escolher a melhor solução para cada projeto.",
      text3: "Na nossa loja, encontra confiança, eficiência e resultados à altura das suas expectativas."
    },
    products: {
      title: "Produtos Naturais",
      subtitle: "Soluções sustentáveis para construção e decoração",
      viewMore: "Saber Mais"
    },
    customMix: {
      title: "Mistura Personalizada",
      subtitle: "Crie a sua cor única",
      description: "Na Pigmentos, oferecemos um serviço exclusivo de mistura de cores personalizada. Com equipamento de última geração, conseguimos fazer à sua medida qualquer cor que imagine.",
      features: ["Cor à medida", "Leitura em loja ou em obra", "Atendimento especializado", "Bases CIN e ARGA"],
      formTitle: "Solicite os seus produtos",
      form: {
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        message: "Descreva o que precisa",
        submit: "Enviar Pedido"
      }
    },
    catalogs: {
      title: "Catálogos de Cores",
      subtitle: "Explore as nossas paletas de cores",
      viewCatalog: "Ver Catálogo"
    },
    portfolio: {
      title: "Portfólio & Inspiração",
      subtitle: "Projetos que inspiram"
    },
    contact: {
      title: "Contactos",
      subtitle: "Estamos aqui para ajudar",
      address: "Morada",
      phone: "Telefone",
      email: "Email",
      social: "Redes Sociais",
      formTitle: "Envie-nos uma mensagem",
      form: {
        name: "Nome",
        email: "Email",
        subject: "Assunto",
        message: "Mensagem",
        submit: "Enviar Mensagem"
      }
    },
    footer: {
      description: "A sua loja de tintas de confiança em Oeiras. Qualidade, variedade e soluções sustentáveis.",
      quickLinks: "Links Rápidos",
      contact: "Contacto",
      followUs: "Siga-nos",
      rights: "Todos os direitos reservados."
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      customMix: "Custom Mix",
      simulation: "Simulation",
      catalogs: "Catalogs",
      portfolio: "Portfolio",
      contact: "Contact"
    },
    hero: {
      title: "Find your color, made to measure.",
      subtitle: "Professional paints, custom mixing and sustainable construction solutions.",
      cta: "Discover More",
      secondary: "We mix the color you want, made to measure."
    },
    highlights: {
      mix: {
        title: "Custom Mixing",
        description: "We create your color, made to measure, with cutting-edge technology."
      },
      variety: {
        title: "Paint Variety",
        description: "Wide range of professional paints from the best brands."
      },
      natural: {
        title: "Natural Solutions",
        description: "Eco-friendly products for sustainable construction."
      }
    },
    about: {
      title: "About Us",
      subtitle: "PIGMENTOS was born thinking of you",
      text1: "At PIGMENTOS, we are paint specialists with over 20 years of experience in the market. Over the years, we have closely understood the needs of those who build, renovate and transform spaces, from industry professionals to private clients.",
      text2: "We offer a wide range of paint solutions and services, combining quality, competitive prices and a strategic location with available parking for your convenience. More than selling products, we provide personalized service, helping you choose the best solution for each project.",
      text3: "In our store, you will find trust, efficiency and results that meet your expectations."
    },
    products: {
      title: "Natural Products",
      subtitle: "Sustainable solutions for construction and decoration",
      viewMore: "Learn More"
    },
    customMix: {
      title: "Custom Mixing",
      subtitle: "Create your unique color",
      description: "At Pigmentos, we offer an exclusive custom color mixing service. With state-of-the-art equipment, we can mix any color you imagine, made to measure.",
      features: ["Color made to measure", "Read in store or on site", "Specialized service", "CIN and ARGA bases"],
      formTitle: "Request your Products",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Describe what you need",
        submit: "Submit Request"
      }
    },
    catalogs: {
      title: "Color Catalogs",
      subtitle: "Explore our color palettes",
      viewCatalog: "View Catalog"
    },
    portfolio: {
      title: "Portfolio & Inspiration",
      subtitle: "Projects that inspire"
    },
    contact: {
      title: "Contact",
      subtitle: "We are here to help",
      address: "Address",
      phone: "Phone",
      email: "Email",
      social: "Social Media",
      formTitle: "Send us a message",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        submit: "Send Message"
      }
    },
    footer: {
      description: "Your trusted paint store in Oeiras. Quality, variety and sustainable solutions.",
      quickLinks: "Quick Links",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved."
    }
  }
};
